export type CloseReason = (typeof closeReasons)[number] | "other";

export const closeReasons = [
    "This Request resulted in a successful placement",
    "Referral information was given to the client",
    "An appropriate referral could not be made",
] as const;